<template>
	<div class="content-wrapper" v-if="isloaded">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId" @openPopup="openPopup"></table-view>
				</sf-card>
			</div>
		</div>
		<CarSaleMstPopup :scrId="scrId" ref="carSaleMstPopupView"></CarSaleMstPopup>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import SearchView from './Search/Search';
import TableView from './Table/Table';
import CarSaleMstPopup from './Popup/Popup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { isloaded: false };
	},
	async created() {
		try {
			this.isloaded = false;
			this.$sf_toggleLoading(true);
			// await this.getCommCodesOnce_(); // 한번에 공통 코드 부르기
			this.setState_({ key: 'isMqyUser', value: await this.inclManyUsrGrp_(['MQYAP', 'OS']) });
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.isloaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	components: { SearchView, TableView, CarSaleMstPopup },
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		openPopup(row) {
			this.$refs.carSaleMstPopupView.open(row);
		}
	}
};
</script>

<style></style>
